import { Input } from '@etg/wings';
import ReactTextMask from 'react-text-mask';
import { jsx as _jsx } from "react/jsx-runtime";
const MaskedInput = _ref => {
  let {
    mask,
    onBlur,
    onChange,
    pipe,
    value,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(ReactTextMask, {
    mask: mask,
    onBlur: onBlur,
    onChange: onChange,
    pipe: pipe,
    render: (maskedRef, rest) => /*#__PURE__*/_jsx(Input, {
      ...props,
      ...rest,
      ref: maskedRef
    }),
    value: value
  });
};
export default MaskedInput;